//TODO: update this file later
// import { ContentWrapper } from "~/components/ContentWrapper.tsx";
// import { buttonVariants } from "@acme/ui/button";
// import { usePageTitleUpdate } from "~/hooks/usePageTitleUpdate.ts";

// import { Link } from "@tanstack/react-router";
import type { FunctionComponent } from "react";

export const NotFound404Page: FunctionComponent = () =>
{
  // usePageTitleUpdate("404");

  return (
    <div className={"size-full flex-col flex items-center justify-center pt-20 pb-36 px-5"}>
      {/*
      <ContentWrapper className={"flex flex-col items-center justify-center gap-4 text-center max-xs:gap-2"}>
        <h1 className="mb-4 text-7xl font-bold tracking-tight max-md:text-6xl">404</h1>
        <p className="text-3xl font-bold tracking-tight max-md:text-2xl max-xs:text-xl">
          Hmm... da ist wohl etwas schief gelaufen.
        </p>
        <p className="mb-4 text-xl font-light max-md:text-base max-w-[700px]">
          Diese Seite konnte nicht gefunden werden. Vielleicht findest du vom Dashboard aus, was du suchst.
        </p>
        <Link to={"/dashboard"} className={buttonVariants({ variant: "default" })}>
          Zurück zum Dashboard
        </Link> 
      </ContentWrapper>
      */}
    </div>
  );
};
